import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
    Box,
    Typography,
    Grid,
    Pagination,
    Container,
    Card,
    CardContent,
    Modal,
    Button,
    InputAdornment,
    TextField,
    CircularProgress,
} from '@mui/material';
import { Dialog, DialogContentText, DialogContent, DialogTitle, DialogActions } from '@mui/material';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import PersonIcon from '@mui/icons-material/Person';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import LeadService from '../../core/services/leadsService';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import { format } from 'date-fns';
import { debounce, throttle } from 'lodash';
import LinearProgress from '@mui/material/LinearProgress';
import { Paper, Stack } from '@mui/material';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import toast from 'react-hot-toast';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import { Autocomplete } from '@mui/material';
import '../ServicesMenu/servicesMenu.css';
import { GlobalStyles } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
import Slide from '@mui/material/Slide';
import LogoutExpiredModal from '../../components/LogoutExpiredModal';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { saveAs } from "file-saver";
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
const useStyles = makeStyles((theme) => ({
    tableForSales: {
        // [theme.breakpoints.down('md')]: {
        //     width: '1070px',
        // },
        // [theme.breakpoints.between('md', 'xmd')]: {
        //     width: '1150px',
        // },
        // [theme.breakpoints.down('lg')]: {
        //     width: '1070px',
        // },
    },
}));
const GetParentSubChild = () => {
    const [ReferralSubChild, setReferralSubChild] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [parentDetails, setParentDetails] = useState(null);
    const location = useLocation();
    const { id } = useParams();
    const { parentId, name, last_name } = location.state || {};
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const abortControllerRef = useRef(null);
    const classes = useStyles();
    const userData = JSON.parse(localStorage.getItem('user'));
    const userType = userData?.user?.user_type;
    const [mainUserDetails, setMainUserDetails] = useState(null);
    const [loadingAllDataCSv, setLoadingAllDataCSv] = useState(false);

    const GetReferralSubChild = async (currentPage, searchTerm, id) => {
        try {
            setLoading(true);
            let isPaginated = true;
            let res;
            if (userType === 'admin') {
                res = await LeadService.AdminGetReferralSalesDetails(isPaginated, currentPage, searchTerm, id);
            } else if (userType === 'sales') {
                res = await LeadService.GetReferralSalesDetails(isPaginated, currentPage, searchTerm, id);
            } else {
                console('Invalid user type');
            }
            if (res?.data?.success) {
                setReferralSubChild(res?.data?.childUser?.data);
                setParentDetails(res.data.parentUser);
                setMainUserDetails(res?.data?.mainUser);
                setCurrentPage(res?.data?.childUser?.current_page);
                setTotalPages(Math.ceil(res?.data?.childUser?.total / res?.data?.childUser?.per_page));
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setIsLoading(false);
            setLoading(false);
        }
    };
    const throttledGetReferralSubChild = useCallback(
        throttle((currentPage, searchTerm, id, signal) => {
            GetReferralSubChild(currentPage, searchTerm, id, signal);
        }, 2000),
        []
    );

    // Debounced function to delay the API call until the user stops typing
    const fetchGetReferralSubChild = useCallback(
        debounce((currentPage, searchTerm, id) => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            throttledGetReferralSubChild(currentPage, searchTerm, id, abortController.signal);
        }, 300),
        [throttledGetReferralSubChild]
    );
    useEffect(() => {
        fetchGetReferralSubChild(currentPage, searchTerm, id);
    }, [currentPage, searchTerm, id]);

    const handleSearchTerm = (event) => {
        setSearchTerm(event.target.value);
    };
    const adjustTimeBasedOnOffsetForReceivedData = (dateString, offsetInHours) => {
        // Create a date object from the UTC date string
        const date = new Date(dateString);

        // Ensure the date is in UTC by setting the time zone offset
        // Convert date to milliseconds and then adjust by the user offset
        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

        // Apply the user offset
        utcDate.setHours(utcDate.getHours() + offsetInHours);

        return utcDate;
    };
    const formatDateTime = (date) => {
        const options = { year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
        return date.toLocaleDateString(undefined, options).replace(',', '');
    };
    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };
    const columns = [
        {
            accessorKey: 'id',
            header: 'Sr no',
            size: 40,
            muiTableBodyCellProps: {
                align: 'left',
            },
        },
        {
            accessorKey: 'profile_image',
            header: '',
            Cell: ({ row }) => (
                <div style={{ display: 'flex' }}>
                    <Avatar src={`https://iconnctapp.com/` + row?.original?.profile_image} />
                </div>
            ),
            size: 10,
            enableSorting: false,
        },
        {
            accessorFn: (row) => {
                if (row?.last_name === null) {
                    return row?.name;
                } else {
                    return `${row?.name} ${row?.last_name}`;
                }
            },
            header: 'User Name',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
        },
        {
            accessorKey: 'email',
            header: 'Email ID',
            size: 140,
            // enableClickToCopy: true,
        },
        {
            accessorKey: 'phone',
            header: 'Phone Number',
            size: 80,
            enableSorting: false,
        },
        {
            accessorKey: 'subscription_type',
            header: 'Subscription Type',
            size: 100,
            enableSorting: false,
            Cell: ({ row }) => {
                const subType = row.original.subscription_type;
                return subType ? subType.charAt(0).toUpperCase() + subType.slice(1) : 'N/A';
            },
        },
        {
            accessorKey: 'userExpiryPayment',
            header: 'Paying Member',
            size: 100,
            enableSorting: false,
            Cell: ({ row }) => {
                return row.original.userExpiryPayment ? 'YES' : 'NO';
            },
        },
        {
            accessorKey: 'referred_by',
            header: 'Referred By',
            size: 120,
            enableSorting: false,
            Cell: ({ row }) => {
                const referredBy = row.original.referred_by;
                return referredBy ? `${referredBy.name || ''} ${referredBy.last_name || ''}`.trim() : '-';
            },
        },
        {
            accessorKey: 'created_at',
            header: 'Member Since',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: true,
            size: 50,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: '14px',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.created_at;

                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            id: 'actions',
            enableSorting: false,
            header: 'See More',
            size: 100,
            Cell: ({ row }) => (
                <div style={{ display: 'flex' }}>
                    <IconButton
                        aria-label="view"
                        onClick={() => handleNavigateSubChild(row?.original?.id, parentId, row?.original?.name, row?.original?.last_name)}
                    >
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <VisibilityIcon />
                        </div>
                    </IconButton>
                </div>
            ),
        },
    ];

    const handleNavigateSubChild = (id, parentId) => {
        navigate(`/referralSubChild/${id}`, {
            state: {
                parentId,
                name: name,
                last_name: last_name,
            },
        });
    };
    const HandleBackNavigate = (parentId) => {
        navigate(`/referralSalesDetails/${parentId}`, {
            state: {
                name: name,
                last_name: last_name,
            },
        });
    };
    const handleClear = () => {
        setSearchTerm('');
    };
    const fetchForCsv = async (currentPage, searchTerm, id) => {
        try {
            setLoadingAllDataCSv(true)
            let isPaginated = false;
            let res;
            if (userType === 'admin') {
                res = await LeadService.AdminGetReferralSalesDetails(isPaginated, currentPage, searchTerm, id);
            } else if (userType === 'sales') {
                res = await LeadService.GetReferralSalesDetails(isPaginated, currentPage, searchTerm, id);
            } else {
                console('Invalid user type');
            }

            if (res?.data?.success) {
                await downloadCsv(
                    res?.data?.childUser,
                    res?.data?.parentUser,
                    res?.data?.mainUser
                );
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    const downloadCsv = async (childUsers, parentDetails, mainUserDetails) => {
        try {
            const getUserOffset = () => {
                const offset = localStorage.getItem('userOffset');
                return offset ? parseFloat(offset) : 0;
            };
            const userOffset = getUserOffset();
            const csvRows = [];

            // Get Current Date/Time/
            const currentDateTime = formatDateTime(new Date());

            // Add Parent Details Section with Parent Name and Current Date/Time
            if (parentDetails) {
                // const parentTitle = `Parent Details - ${parentDetails.name || ''} ${parentDetails.last_name || ''} - ${currentDateTime}`;
                csvRows.push([`Parent Details - ${parentDetails.name || ''} ${parentDetails.last_name || ''}`]);
                csvRows.push([`Export Date:${currentDateTime}`]);
                csvRows.push(['Name', 'Email', 'Phone', 'Member Since'].join(',')); // Column headers
                csvRows.push(
                    [
                        (parentDetails?.name || '') + ' ' + (parentDetails?.last_name || ''),
                        parentDetails.email || '',
                        parentDetails.phone || '',
                        parentDetails.created_at ? formatDateTime(adjustTimeBasedOnOffsetForReceivedData(parentDetails.created_at, userOffset)) : '',
                    ].join(',')
                ); // Data row
                csvRows.push(''); // Blank row for separation
            }

            // Add Main User Details Section with updated title format
            if (mainUserDetails) {
                // const mainUserTitle = `${mainUserDetails.name || ''} ${mainUserDetails.last_name || ''} (Referral by: ${parentDetails?.name || ''} ${parentDetails?.last_name || ''} - Email:(${parentDetails?.email || ''}))`;

                csvRows.push([`${mainUserDetails.name} ${mainUserDetails.last_name}`]);
                csvRows.push([`Referral by: ${parentDetails?.name || ''} ${parentDetails?.last_name || ''}`]);
                csvRows.push([`(${parentDetails?.email || ''})`]);
                csvRows.push(['Name', 'Email', 'Phone', 'Subscription Type', 'Paying Member', 'Referred By', 'Member Since'].join(',')); // Column headers
                csvRows.push(
                    [
                        (mainUserDetails?.name || '') + ' ' + (mainUserDetails?.last_name || ''),
                        mainUserDetails.email || '',
                        mainUserDetails.phone || '',
                        mainUserDetails.subscription_type ? mainUserDetails.subscription_type.charAt(0).toUpperCase() + mainUserDetails.subscription_type.slice(1) : '',
                        mainUserDetails.userExpiryPayment ? 'Yes' : 'No',
                        (mainUserDetails.referred_by?.name || '') + ' ' + (mainUserDetails.referred_by?.last_name || ''),
                        mainUserDetails.created_at
                            ? formatDateTime(adjustTimeBasedOnOffsetForReceivedData(mainUserDetails.created_at, userOffset))
                            : '',
                    ].join(',')
                ); // Data row
                csvRows.push(''); // Blank row for separation
            }

            // Add Referral/Child Details Section
            if (childUsers && childUsers?.length >= 0) {
                // const childTitle = `Child Details (Referral by: ${mainUserDetails?.name || ''} ${mainUserDetails?.last_name || ''} - Email: (${mainUserDetails?.email || ''}))`;
                csvRows.push([`Child Details`]);
                csvRows.push([`(Referral by: ${mainUserDetails?.name || ''} ${mainUserDetails?.last_name || ''}`]);
                csvRows.push([`(${mainUserDetails?.email || ''})`]);
                csvRows.push(['Name', 'Email', 'Phone', 'Subscription Type', 'Paying Member', 'Referred By', 'Member Since'].join(',')); // Column headers
                childUsers?.forEach((child) => {
                    const referredBy = child.referred_by
                        ? `${child.referred_by.name || ''} ${child.referred_by.last_name || ''}`.trim()
                        : '';
                    csvRows.push(
                        [
                            (child?.name || '') + ' ' + (child?.last_name || ''),
                            child.email || '',
                            child.phone || '',
                            child.subscription_type ? mainUserDetails.subscription_type.charAt(0).toUpperCase() + mainUserDetails.subscription_type.slice(1) : '',
                            child.userExpiryPayment ? 'Yes' : 'No',
                            referredBy || '',
                            child.created_at ? formatDateTime(adjustTimeBasedOnOffsetForReceivedData(child.created_at, userOffset)) : '',
                        ].join(',')
                    ); // Data rows
                });
            }

            // Combine rows and convert into CSV format
            const csvContent = csvRows.join('\n');

            // Create and download the CSV file
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            saveAs(blob, 'ReferralDetails.csv');
        } catch (error) {
            toast.error('Failed to download CSV file: ' + error.message);
        } finally {
            setLoadingAllDataCSv(false);
        }
    };


    return (
        <>
            <div>
                <Box>
                    <Button
                        onClick={() => HandleBackNavigate(parentId)}
                        sx={{ background: '#efefef', marginBottom: '10px', padding: '6px', '&:hover': { background: '#cecaca' } }}
                    >
                        <ArrowBackIosIcon style={{ color: '#8f7f7f', marginLeft: '6px' }} />
                    </Button>
                </Box>
                <div style={{ marginBottom: '15px' }}> {loading && <LinearProgress />}</div>
                <div style={{ display: 'flex', gap: '20px', overflowX: 'auto' }}>
                    <Box style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
                        {parentDetails && (
                            <Card
                                sx={{
                                    padding: '20px',
                                    borderRadius: '22px',
                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                    background: 'white',
                                    marginBottom: '20px',
                                }}
                            >
                                <CardContent>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                        <Avatar
                                            alt={parentDetails.name}
                                            src={`https://iconnctapp.com/${parentDetails?.profile_image}`} // Replace with base URL
                                            sx={{ width: 56, height: 56 }}
                                        />
                                        <Box>
                                            <Typography variant="h6">{`${parentDetails.name || ''} ${parentDetails.last_name || ''}`}</Typography>
                                            <div style={{ display: 'flex', gap: '3px' }}>
                                                <EmailIcon />
                                                <Typography variant="body2" color="textSecondary">
                                                    {parentDetails.email || ''}
                                                </Typography>
                                            </div>
                                            {parentDetails.phone && (
                                                <>
                                                    <div style={{ display: 'flex', gap: '3px' }}>
                                                        <LocalPhoneIcon />
                                                        <Typography variant="body2" color="textSecondary">
                                                            {parentDetails.phone || ''}
                                                        </Typography>
                                                    </div>

                                                </>

                                            )}
                                        </Box>
                                    </Box>
                                </CardContent>
                            </Card>
                        )}
                        {parentDetails && mainUserDetails && (<>
                            <div style={{ marginTop: '50px' }}>
                                <ArrowForwardIcon sx={{ fontSize: '50px' }} />
                            </div>
                        </>)}
                        {mainUserDetails && (
                            <Card
                                sx={{
                                    padding: '20px',
                                    borderRadius: '22px',
                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                    background: 'white',
                                    marginBottom: '20px',
                                }}
                            >
                                <CardContent>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                        <Avatar
                                            alt={mainUserDetails.name}
                                            src={`https://iconnctapp.com/${mainUserDetails?.profile_image}`} // Replace with base URL
                                            sx={{ width: 56, height: 56 }}
                                        />
                                        <Box>
                                            <Typography variant="h6">{`${mainUserDetails.name || ''} ${mainUserDetails.last_name || ''}`}</Typography>
                                            <div style={{ display: 'flex', gap: '3px' }}>
                                                <EmailIcon />
                                                <Typography variant="body2" color="textSecondary">
                                                    {mainUserDetails.email || ''}
                                                </Typography>
                                            </div>
                                            {mainUserDetails.phone && (
                                                <>
                                                    <div style={{ display: 'flex', gap: '3px' }}>
                                                        <LocalPhoneIcon />
                                                        <Typography variant="body2" color="textSecondary">
                                                            {mainUserDetails.phone || ''}
                                                        </Typography>
                                                    </div>

                                                </>

                                            )}
                                        </Box>
                                    </Box>
                                </CardContent>
                            </Card>
                        )}
                    </Box>
                </div>

                <div>
                    <Box style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
                        <div style={{ display: 'grid', marginBottom: '10px', gap: '5px' }}>
                            <Button variant="contained" color="primary" disabled={loadingAllDataCSv} onClick={() => fetchForCsv(currentPage, searchTerm, id)} style={{ marginTop: '1rem' }}>
                                Export CSV
                                {loadingAllDataCSv && <CircularProgress size={18} style={{ color: "#3b3bbb" }} />}
                            </Button>
                            <TextField
                                value={searchTerm}
                                onChange={handleSearchTerm}
                                sx={{
                                    width: {
                                        xs: '150px',
                                        sm: '200px',
                                        md: '250px'
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                    },
                                }}
                                placeholder="Search..."
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={handleClear} aria-label="clear search">
                                                <ClearIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                variant="outlined"
                            />

                        </div>
                    </Box>
                </div>
                <Box className={classes.tableForSales}>
                    <Card style={{ borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                        <MaterialReactTable
                            columns={columns}
                            data={ReferralSubChild}
                            state={{ isLoading: isLoading }}
                            muiCircularProgressProps={{
                                color: 'secondary',
                                thickness: 5,
                                size: 55,
                            }}
                            muiSkeletonProps={{
                                animation: 'pulse',
                                height: 28,
                            }}
                            enableTopToolbar={false}
                            enableFacetedValues={true}
                            enableStickyHeader={true}
                            enableDensityToggle={false}
                            enableHiding={false}
                            showSkeletons={false}
                            enableColumnFilterModes={false}
                            enableColumnActions={false}
                            enableColumnOrdering={false}
                            enableFullScreenToggle={false}
                            enableColumnFilters={false}
                            enablePagination={false}
                            getRowId={(row) => row.id}
                            initialState={{
                                showColumnFilters: false,
                                showGlobalFilter: false,
                            }}
                            muiTableBodyRowProps={{
                                sx: {
                                    backgroundColor: '#f5f5f5', // Default row background color
                                    '&:nth-of-type(odd)': {
                                        backgroundColor: '#ffffff', // Alternate rows with white
                                    },
                                    '&:hover': {
                                        backgroundColor: '#e0e0e0', // Hover effect
                                        cursor: 'pointer',
                                    },
                                },
                            }}
                        />
                    </Card>
                    <Pagination
                        count={totalPages}
                        color="primary"
                        page={currentPage}
                        onChange={(event, value) => setCurrentPage(value)}
                        style={{ marginTop: '-40px', zIndex: 1000, position: 'relative', display: 'flex', justifyContent: 'flex-end' }}
                    />
                </Box>
            </div>
        </>
    );
};

export default GetParentSubChild;
